import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAmexLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 16",
	width: 24,
	height: 16,
	"aria-hidden": "true",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_66_2093)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M22.1056 0H2.16485C1.06355 0 0.170776 0.89543 0.170776 2V14C0.170776 15.1046 1.06355 16 2.16485 16H22.1056C23.2069 16 24.0997 15.1046 24.0997 14V2C24.0997 0.89543 23.2069 0 22.1056 0Z",
				fill: "#016FD0"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M13.894 13.3939V7.69246L24.0115 7.70157V9.27646L22.8421 10.5299L24.0115 11.7947V13.403H22.1444L21.1522 12.3049L20.167 13.4072L13.894 13.3939Z",
				fill: "#FFFFFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M14.5698 12.7688V8.31991H18.3309V9.3448H15.7876V10.0405H18.2703V11.0483H15.7876V11.7316H18.3309V12.7688H14.5698Z",
				fill: "#016FD0"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M18.3122 12.7688L20.3933 10.5418L18.3121 8.32H19.9229L21.1946 9.73003L22.47 8.32H24.0116V8.35501L21.9747 10.5418L24.0116 12.7057V12.7688H22.4545L21.1602 11.3446L19.8792 12.7688H18.3122Z",
				fill: "#016FD0"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M14.366 2.63196H16.8048L17.6614 4.58281V2.63196H20.6723L21.1915 4.09353L21.7125 2.63196H24.0116V8.33335H11.8611L14.366 2.63196Z",
				fill: "#FFFFFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M14.8277 3.25136L12.8596 7.69653H14.2094L14.5808 6.80637H16.5927L16.9638 7.69653H18.3473L16.3873 3.25136H14.8277ZM14.9969 5.8088L15.5871 4.39372L16.1769 5.8088H14.9969Z",
				fill: "#016FD0"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M18.3289 7.69574V3.25065L20.2263 3.25719L21.2027 5.98992L22.1854 3.25065H24.0116V7.69574L22.8365 7.70617V4.65282L21.7272 7.69574H20.6546L19.5223 4.64239V7.69574H18.3289Z",
				fill: "#016FD0"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_66_2093",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 23.9289,
			height: 16,
			fill: "white",
			transform: "translate(0.170776)"
		})
	}) })]
});
export default SvgAmexLogo;
